module.exports = __webpack_public_path__ + "static/img/1511.17d4340.png";